
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DocSection, listDocSection} from '@/service/kk-help-doc/doc-section';
import {hideLoading, showLoading, showWarning} from '@/utils/message';
import DocSectionTree from '@/views/doc/DocSectionTree.vue';

export interface DocSectionExt extends DocSection {
  children: DocSectionExt[];
  active: boolean;
  spread: boolean;
}

@Component({
  components: {DocSectionTree},
})
export default class DocSectionList extends Vue {
  @Prop({required: true, type: String})
  public bookId!: string;

  @Prop({required: false})
  public initSectionId?: string;

  public sectionList: DocSection[] = [];

  public rootNodes: DocSectionExt[] = [];

  public map: Map<string, DocSectionExt> = new Map<string, DocSectionExt>();

  @Watch('bookId')
  public watchBookId() {
    this.fetchData();
  }

  public created() {
    this.fetchData(this.initSectionId);
  }

  public fetchData(initSectionId?: string) {
    showLoading();
    listDocSection(this.bookId)
        .then((list) => {
          const map: Map<string, DocSectionExt> = new Map<string, DocSectionExt>();
          for (const docSection of list) {
            map.set(docSection.id, Object.assign(docSection, {children: [], active: false, spread: false}));
          }
          // 构建树
          const rootNodes: DocSectionExt[] = [];
          const values = map.values();
          let val = values.next();
          while (!val.done) {
            const docSection = val.value;
            const parent = map.get(docSection.parentId || '');
            if (parent) {
              parent.children.push(docSection);
              parent.children.sort((o1, o2) => o1.seqNo - o2.seqNo);
            } else {
              rootNodes.push(docSection);
            }
            val = values.next();
          }
          this.rootNodes = rootNodes;
          this.map = map;
          // 如果需要一开始就导航到某一个章节，那么查找这个章节的信息
          if (initSectionId) {
            this.switchToSection(initSectionId);
          }
        })
        .catch(showWarning)
        .finally(hideLoading);
  }

  public switchToSection(sectionId: string) {
    const section = this.map.get(sectionId);
    if (!section) {
      return;
    }
    // 清除已有的章节激活状态
    const values = this.map.values();
    let val = values.next();
    while (!val.done) {
      const sec = val.value;
      if (sec.active) {
        sec.active = false;
      }
      val = values.next();
    }
    // 查找所有父级，更新状态
    const ancestors = this.getSectionAncestors(section);
    for (const ancestor of ancestors) {
      ancestor.spread = true;
    }
    section.active = true;
    this.$emit('select', [...ancestors, section]);
  }

  public getSectionMap(): Map<string, DocSectionExt> {
    return this.map;
  }

  public getSectionAncestors(section: DocSectionExt): DocSectionExt[] {
    const ancestors: DocSectionExt[] = [];
    let sec = section;
    while (true) {
      if (!sec.parentId) {
        break;
      }
      const parent = this.map.get(sec.parentId);
      if (!parent) {
        break;
      }
      ancestors.push(parent);
      sec = parent;
    }
    return ancestors.reverse();
  }

  public handleSelect(sections: DocSectionExt[]) {
    // 将目前选中的更新下状态，已有选中状态的状态去除
    const values = this.map.values();
    let val = values.next();
    while (!val.done) {
      const sec = val.value;
      if (sec.active) {
        sec.active = false;
      }
      val = values.next();
    }
    const selectedSection = sections[sections.length - 1];
    selectedSection.active = true;
    this.$emit('select', sections);
  }

  public handleFold(section: DocSectionExt) {
    section.spread = false;
  }

  public handleExpand(section: DocSectionExt) {
    section.spread = true;
  }
}
